module.exports = __webpack_public_path__ + "media/images/emblems/Neuchatel_city_coat_of_arms-b9c6d5f582bc337022f6ea5fc180835b.svg";